import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import Modal from '../Modal'

interface NoCompletedTagsWarningModalProps {
  isOpen: boolean
  onClose: () => void
  onProceed: () => void
}

const NoCompletedTagsWarningModal: React.FC<
  NoCompletedTagsWarningModalProps
> = ({ isOpen, onClose, onProceed }) => {
  if (!isOpen) return null

  return (
    <Modal onClose={onClose}>
      <div className={css(styles.warningModal)}>
        <div className={css(styles.warningHeader)}>
          <div className={css(styles.warningHeaderIcon)}>
            <i className="fa-solid fa-exclamation-triangle" />
          </div>
          <h2 className={css(styles.warningHeaderTitle)}>No Completed Tags</h2>
        </div>
        <div className={css(styles.warningContent)}>
          <p>Report contains no completed tags, would you like to continue?</p>
        </div>
        <div className={css(styles.warningActions)}>
          <button onClick={onClose} className={css(styles.cancelButton)}>
            Cancel
          </button>
          <button onClick={onProceed} className={css(styles.proceedButton)}>
            Yes, Continue
          </button>
        </div>
      </div>
    </Modal>
  )
}

const styles = StyleSheet.create({
  warningModal: {
    padding: '32px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    boxShadow:
      '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    margin: '0 auto',
  },
  warningHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px',
    color: '#F59E0B',
  },
  warningHeaderIcon: {
    fontSize: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    backgroundColor: '#FEF3C7',
    borderRadius: '50%',
  },
  warningHeaderTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#1F2937',
    margin: 0,
  },
  warningContent: {
    marginBottom: '32px',
    fontSize: '16px',
    color: '#4B5563',
    lineHeight: '1.6',
    textAlign: 'center',
  },
  warningActions: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
  },
  cancelButton: {
    padding: '12px 24px',
    backgroundColor: '#6B7280',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s',
    minWidth: '120px',
    '&:hover': {
      backgroundColor: '#4B5563',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
  proceedButton: {
    padding: '12px 24px',
    backgroundColor: '#1C64F2',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.2s',
    minWidth: '120px',
    '&:hover': {
      backgroundColor: '#1955CC',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
})

export default NoCompletedTagsWarningModal
